import sample_01 from './forceHeavyDuty.jpg';

export const forceHeavyDutyImpressions = {
    sample_01,
};
